import Modal from './modal';

export default function resetPwdFormControl() {

  // success pwd reset
  let addressModalOpened = false;
  if($('.reset-pwd-completed').length) {
    if (!addressModalOpened) {
      addressModalOpened = true;
      const link = $('.reset-pwd-completed');
      new Modal({
        body: `<h2 class="blue">You have successfully reset your password on EmbassyCard. You can continue to Login to your account.</h2>`,
        fnContinue: () => {
          link.trigger('click');
        },
        fnOnClose: () => {
          addressModalOpened = false;
        },
        backButtonState: 'disabled',
        continueButtonText: 'Login',
      });
      return false;
    }
    return true;
  };

}
